// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".country-flag{width:25px}.country-item{width:50px;height:50px;display:flex;flex-direction:column;align-items:center}.selected-country{border:1px solid;border-color:#28a745}", ""]);
// Exports
module.exports = exports;
